import { render } from "./CollectionSources.vue?vue&type=template&id=70e9f60b"
import script from "./CollectionSources.vue?vue&type=script&lang=js"
export * from "./CollectionSources.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__